import SlimSelect from 'slim-select';

export const fSelectInit = (item: any) => {
    if (item !== null && item !== undefined) {
        let showSearch = false;
        let searchPlaceholder = 'Поиск';
        if (item.getAttribute('data-search')) {
            showSearch = true;
        }
        if (item.getAttribute('data-search-text')) {
            searchPlaceholder = item.getAttribute('data-search-text');
        }
        let wintop = 0;

        const select = new SlimSelect({
            select: item,
            placeholder: 'Выберите...',
            showContent: 'down',
            searchPlaceholder,
            showSearch,
            searchText: 'Не найдено',
            searchFocus: false,
            beforeOpen: () => {
                if (window.matchMedia('(max-width: 767px)').matches) {
                    const ssMain = item.nextElementSibling;
                    const ssContent = ssMain?.querySelector('.ss-content');
                    if (ssContent !== null && ssContent !== undefined) {
                        ssContent.style.display = 'flex';
                    }
                    wintop = window.scrollY;
                    document.body.classList.add('select-open');
                    document.body.style.top = `${-wintop}px`;
                    document.body.style.setProperty('--wintop', `${wintop}px`);
                    const modal = item.closest('.modal.is-open');
                    if (modal !== null && modal !== undefined) {
                        const modalContainer =
                            modal.querySelector('.modal__container');
                        if (
                            modalContainer !== null &&
                            modalContainer !== undefined &&
                            ssContent !== null &&
                            ssContent !== undefined
                        ) {
                            if (
                                ssContent.scrollHeight >
                                modalContainer.scrollHeight
                            ) {
                                document.body.classList.add(
                                    'select-open--visible'
                                );
                            }
                        }
                    }
                }
            },
            afterClose: () => {
                document.body.classList.remove('select-open');
                document.body.classList.remove('select-open--visible');
                document.body.style.removeProperty('top');
                document.body.style.removeProperty('--wintop');
                if (window.matchMedia('(max-width: 767px)').matches) {
                    const ssMain = item.nextElementSibling;
                    const ssContent = ssMain?.querySelector('.ss-content');
                    if (ssContent !== null && ssContent !== undefined) {
                        ssContent.style.display = 'none';
                    }
                    window.scroll(0, wintop);
                }
            },
        });

        item.addEventListener('change', () => {
            item.classList.remove('error');
            item.classList.add('filled');
            const err = item.nextElementSibling;
            if (err.classList.contains('error-message')) {
                err.remove();
            }
        });

        const ssMain = item.nextElementSibling;
        const maskSelect = document.createElement('div');
        maskSelect.className = 'ss-mask';
        ssMain?.appendChild(maskSelect);
        maskSelect.addEventListener('click', () => {
            select.close();
        });

        const ssContent = ssMain.querySelector('.ss-content');
        const ssClose = document.createElement('div');
        ssClose.className = 'ss-close';
        ssContent?.appendChild(ssClose);

        // Close select on drag
        let start;
        ssClose.addEventListener('touchstart', (e) => {
            if (window.matchMedia('(max-width: 767px)')) {
                e.stopPropagation();
                const touch = e.touches[0] || e.changedTouches[0];
                start = touch.pageY;
            }
        });
        ssClose.addEventListener('touchmove', (e) => {
            if (window.matchMedia('(max-width: 767px)')) {
                e.stopPropagation();
                const touch = e.touches[0] || e.changedTouches[0];
                const y = touch.pageY;
                const diff = y - start;
                if (diff > 0) {
                    ssContent?.style.setProperty('--select-top', `${diff}px`);
                }
            }
        });
        ssClose.addEventListener('touchend', (e) => {
            if (window.matchMedia('(max-width: 767px)')) {
                select.close();
                setTimeout(() => {
                    ssContent?.style.removeProperty('--select-top');
                }, 3000);
            }
        });
        ssClose.addEventListener('click', (e) => {
            if (window.matchMedia('(max-width: 767px)')) {
                select.close();
                setTimeout(() => {
                    ssContent?.style.removeProperty('--select-top');
                }, 3000);
            }
        });

        const placeholder = item.querySelector(
            'option[data-placeholder="true"]'
        );
        if (placeholder !== null && placeholder !== undefined) {
            placeholder.innerHTML = '';
            placeholder.removeAttribute('value');
        }
    }
};

export const fSelectUpdate = (item: any) => {
    setTimeout(() => {
        if (item.slim) {
            item.slim.destroy();
            fSelectInit(item);
        }
    }, 0);
};

export default function fSelect(selectClass: string) {
    const select = document.querySelectorAll(
        `select${selectClass}:not([data-ssid])`
    );

    select.forEach((item) => {
        fSelectInit(item);
    });
}

document.addEventListener('DOMContentLoaded', () => {
    fSelect('.js-select');
});
